import { ModuleNameToModuleRegistry } from '../../types/types';
import { ApiPricingChangesTopBarSlim } from './components/ApiPricingChangesTopBarSlim';
import { InRetryTopBarSlim } from './components/InRetryTopBarSlim';
import { DomainLockdownTopBarSlim } from './components/DomainLockdownTopBarSlim';
import { BasicPendingInvoiceTopBarSlim } from './components/BasicPendingInvoiceTopBarSlim';
import { DomainLockdownTeamTopBarSlim } from './components/DomainLockdownTeamTopBarSlim';
import { HasOverageTopBarSlim } from './components/HasOverageTopBarSlim';
import { HasOverageTeamTopBarSlim } from './components/HasOverageTeamTopBarSlim';
import { UseCaseMarketResearchTopBarSlim } from './components/UseCaseMarketResearchTopBarSlim';
import { UseCaseCustomerSatisfactionTopBarSlim } from './components/UseCaseCustomerSatisfactionTopBarSlim';
import { UseCaseEmployeeEngagementTopBarSlim } from './components/UseCaseEmployeeEngagementTopBarSlim';
import { UseCaseCourseTrainingFeedbackTopBarSlim } from './components/UseCaseCourseTrainingFeedbackTopBarSlim';
import { UseCasePerformanceEvaluationTopBarSlim } from './components/UseCasePerformanceEvaluationTopBarSlim';
import { UseCaseAcademicResearchTopBarSlim } from './components/UseCaseAcademicResearchTopBarSlim';
import { UseCaseEventFeedbackTopBarSlim } from './components/UseCaseEventFeedbackTopBarSlim';
import { UseCaseQuizzesAssessmentsTopBarSlim } from './components/UseCaseQuizzesAssessmentsTopBarSlim';
import { UseCaseBallotVotingTopBarSlim } from './components/UseCaseBallotVotingTopBarSlim';
import { UseCaseFormsApplicationsTopBarSlim } from './components/UseCaseFormsApplicationsTopBarSlim';
import { UseCasePlanningRegistrationTopBarSlim } from './components/UseCasePlanningRegistrationTopBarSlim';
import { UseCaseJustForFunTopBarSlim } from './components/UseCaseJustForFunTopBarSlim';
import { UseCaseOtherTopBarSlim } from './components/UseCaseOtherTopBarSlim';
import { UseCaseStudentCommunityFeedbackTopBarSlim } from './components/UseCaseStudentCommunityFeedbackTopBarSlim';

const topBarSlims: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  api_pricing_changes_top_bar_slim: ApiPricingChangesTopBarSlim,
  domain_lockdown_top_bar_slim: DomainLockdownTopBarSlim,
  in_retry_top_bar_slim: InRetryTopBarSlim,
  basic_pending_invoice_top_bar_slim: BasicPendingInvoiceTopBarSlim,
  domain_lockdown_team_top_bar_slim: DomainLockdownTeamTopBarSlim,
  has_overage_top_bar_slim: HasOverageTopBarSlim,
  has_overage_group_members_top_bar_slim: HasOverageTeamTopBarSlim,
  use_case_market_research_top_bar_slim: UseCaseMarketResearchTopBarSlim,
  use_case_customer_satisfaction_top_bar_slim: UseCaseCustomerSatisfactionTopBarSlim,
  use_case_employee_engagement_top_bar_slim: UseCaseEmployeeEngagementTopBarSlim,
  use_case_course_training_feedback_top_bar_slim: UseCaseCourseTrainingFeedbackTopBarSlim,
  use_case_performance_evaluation_top_bar_slim: UseCasePerformanceEvaluationTopBarSlim,
  use_case_academic_research_top_bar_slim: UseCaseAcademicResearchTopBarSlim,
  use_case_event_feedback_top_bar_slim: UseCaseEventFeedbackTopBarSlim,
  use_case_quizzes_assessments_top_bar_slim: UseCaseQuizzesAssessmentsTopBarSlim,
  use_case_ballot_voting_top_bar_slim: UseCaseBallotVotingTopBarSlim,
  use_case_forms_applications_top_bar_slim: UseCaseFormsApplicationsTopBarSlim,
  use_case_planning_registration_top_bar_slim: UseCasePlanningRegistrationTopBarSlim,
  use_case_just_for_fun_top_bar_slim: UseCaseJustForFunTopBarSlim,
  use_case_other_top_bar_slim: UseCaseOtherTopBarSlim,
  use_case_student_community_feedback_top_bar_slim: UseCaseStudentCommunityFeedbackTopBarSlim,
});

export default topBarSlims;
